//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { InstagramTaggedProduct } from '@bvengineering/universal-scheduling-gateway-service-types';

import { IInstagramShopsProduct } from '@apis/instagram-shops/instagramShopsApiModel';
import Cuid from '@models/Cuid';
import { ISpatialTagCoordinates } from '@models/ISpatialTagCoordinates';
import { isDefined } from '@utils/filterPredicates';

export interface IShopTag {
  catalogId: string;
  coordinates?: ISpatialTagCoordinates;
  cuid?: Cuid;
  mediaIndex: number;
  productId: string;
  productImageUrl?: string;
  productName?: string;
}

export function toInstagramTaggedProduct(
  product: IShopTag,
): InstagramTaggedProduct {
  return {
    productId: product.productId,
    catalogId: product.catalogId,
    X: product.coordinates?.x,
    Y: product.coordinates?.y,
    mediaIndex: product.mediaIndex,
  };
}

export function toShopTag(product: InstagramTaggedProduct): IShopTag {
  return {
    productId: product.productId,
    catalogId: product.catalogId,
    coordinates:
      isDefined(product.X) && isDefined(product.Y)
        ? { x: product.X, y: product.Y }
        : undefined,
    mediaIndex: product.mediaIndex,
  };
}

export function mapInstagramTaggedProductWithCuidToShopTag(
  cuid: Cuid,
  product: InstagramTaggedProduct,
): IShopTag {
  return {
    catalogId: product.catalogId,
    coordinates:
      isDefined(product.X) && isDefined(product.Y)
        ? { x: product.X, y: product.Y }
        : undefined,
    cuid: cuid,
    mediaIndex: product.mediaIndex,
    productId: product.productId,
  };
}

export function mapIInstagramShopsProductToPartialShopTag(
  product: IInstagramShopsProduct,
): Partial<IShopTag> {
  return {
    productId: product.productId,
    productImageUrl: product.imageUrl,
    productName: product.productName,
  };
}
